import { actionTypes } from '../../constants';
import { GET_ARRANGED_OVERDRAFT_ALERT_ENDPOINT } from '../../constants/urls';
import { RSAA } from 'redux-api-middleware';
import { X_BPI_VERSION_0_8_0 } from '../../constants/VersionConstants';
const {
  GET_ARRANGED_OVERDRAFT_ALERT,
  GET_ARRANGED_OVERDRAFT_ALERT_SUCCESS,
  GET_ARRANGED_OVERDRAFT_ALERT_FAILURE,
  UPDATE_ARRANGED_OVERDRAFT_ALERT,
  UPDATE_ARRANGED_OVERDRAFT_ALERT_SUCCESS,
  UPDATE_ARRANGED_OVERDRAFT_ALERT_FAILURE,
} = actionTypes;

// TODOxCYBG will put new version if its changed
export const getArrangedOverdraftAlert = (data) => ({
  [RSAA]: {
    endpoint: GET_ARRANGED_OVERDRAFT_ALERT_ENDPOINT.replace('{account_id}', data),
    method: 'GET',
    headers: {
      'x-bpi-version': X_BPI_VERSION_0_8_0,
    },
    types: [
      GET_ARRANGED_OVERDRAFT_ALERT,
      GET_ARRANGED_OVERDRAFT_ALERT_SUCCESS,
      GET_ARRANGED_OVERDRAFT_ALERT_FAILURE,
    ],
  },
});
export const arrangedOverdraftAlert = (data, reqBody) => ({
  [RSAA]: {
    endpoint: GET_ARRANGED_OVERDRAFT_ALERT_ENDPOINT.replace('{account_id}', data.account_id),
    method: 'PUT',
    headers: {
      'x-bpi-version': X_BPI_VERSION_0_8_0,
    },
    body: JSON.stringify(reqBody),
    types: [
      UPDATE_ARRANGED_OVERDRAFT_ALERT,
      UPDATE_ARRANGED_OVERDRAFT_ALERT_SUCCESS,
      UPDATE_ARRANGED_OVERDRAFT_ALERT_FAILURE,
    ],
  },
});
